import React, { useEffect, useRef } from 'react';
import Navigation from './Navigation';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import WhatIDoSection from './WhatIDoSection';
import HistorySection from './HistorySection';
import ContactSection from './ContactSection';
import SocialSidebar from './SocialSidebar';
import ErrorBoundary from './ErrorBoundary';
import {APP_VERSION} from '../config';
import profile from '@/config/profile';

const Portfolio = () => {
  const portfolioRef = useRef(null);
  const isLightTheme = profile?.theme === 'light';

  useEffect(() => {
    // Smooth scrolling behavior
    const handleSmoothScroll = (e) => {
      if (e.target.tagName === 'A' && e.target.getAttribute('href')?.startsWith('#')) {
        e.preventDefault();
        const targetId = e.target.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      }
    };

    document.addEventListener('click', handleSmoothScroll);
    return () => document.removeEventListener('click', handleSmoothScroll);
  }, []);

  return (
    <div
      ref={portfolioRef}
      className={`portfolio-container min-h-screen overflow-x-hidden transition-colors duration-300 ${
        isLightTheme ? 'bg-slate-100 text-black' : 'bg-black text-white'
      }`}
    >
      <Navigation />
        <ErrorBoundary>
      <SocialSidebar />
        </ErrorBoundary>
      <main>
        <ErrorBoundary>
          <HeroSection />
        </ErrorBoundary>
        <ErrorBoundary>
        <AboutSection />
        </ErrorBoundary>
        <ErrorBoundary>
        <WhatIDoSection />
        </ErrorBoundary>
        <ErrorBoundary>
        <HistorySection />
        </ErrorBoundary>
        <ErrorBoundary>
        <ContactSection />
        </ErrorBoundary>
      </main>
      
      {/* Footer */}
      <footer className={`border-t py-8 px-8 ${isLightTheme ? 'border-gray-300' : 'border-gray-800'}`}>
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center">
          <div className={`text-sm mb-4 md:mb-0 ${isLightTheme ? 'text-gray-600' : 'text-gray-400'}`}>
            © 2024 Kodoth Group. All rights reserved. V{APP_VERSION}
          </div>
          <div className={`flex space-x-6 text-sm ${isLightTheme ? 'text-gray-600' : 'text-gray-400'}`}>
            <a href="#" className="hover:text-blue-400 transition-colors duration-300">Privacy</a>
            <a href="#" className="hover:text-blue-400 transition-colors duration-300">Terms</a>
            <a href="#" className="hover:text-blue-400 transition-colors duration-300">Cookies</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Portfolio;